// FILE: src/Components/Redirectpage/pinterest.js (FULLY UPDATED)

import React, { useEffect, useState } from "react";
import { Spin, message, Result, Button } from 'antd';
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as authServices from '../../services/authConnect';
import { handleAuthSuccess } from "../../store/Slices/GroupSlice";

import {
  finishSocialConnectNavigation,
  returnFromSocialConnectWithoutResult,
} from "../../utils/socialConnectOrigin";

export default function Pinterest() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [error, setError] = useState('');

    useEffect(() => {
        const handleCallback = async () => {
            const params = new URLSearchParams(window.location.search);
            const code = params.get('code');
            const state = params.get('state');

            if (code && state) {
                try {
                    await authServices.handleCallback('PINTEREST', code, state);
                    message.success("Pinterest connected successfully!");

                    // --- THIS IS THE FIX ---
                    // Dispatch the success action to trigger a data refresh in the main app.
                    const refreshResult =
  await dispatch(
    handleAuthSuccess()
  ).unwrap();

finishSocialConnectNavigation(
  navigate,
  "/Dashboard/GroupsProfile",
  {
    groups:
      refreshResult.groups ||
      [],
  }
);
                } catch (err) {
                    setError(err.message || 'Failed to verify connection with Pinterest.');
                }
            } else {
                setError('Pinterest authentication was cancelled or failed.');
            }
        };
        handleCallback();
    }, [dispatch, navigate]);

    if (error) {
        return (
            <Result
                status="error"
                title="Connection Failed"
                subTitle={error}
                extra={[
                    <Button type="primary" key="console" onClick={() =>
  returnFromSocialConnectWithoutResult(
    navigate
  )
}>
                        Go to Brands & Channels
                    </Button>,
                ]}
            />
        );
    }

    return (
        <div className="flex flex-col justify-center items-center h-screen">
            <Spin size="large" />
            <p className="mt-4 text-lg text-gray-600">Authenticating with Pinterest...</p>
        </div>
    );
}